import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, createBlock as _createBlock, renderList as _renderList, withModifiers as _withModifiers, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/women.png'
import _imports_1 from '@/assets/men.png'
import _imports_2 from '@/assets/video.png'
import _imports_3 from '@/assets/notice-bj.png'


const _withScopeId = n => (_pushScopeId("data-v-3a747340"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my" }
const _hoisted_2 = { class: "my-content hea-column" }
const _hoisted_3 = { class: "member-content hea-column" }
const _hoisted_4 = { class: "hea-row hea-justifyCL operate" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/my/member-ico.png",
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tjrxx" }, "体检人信息", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 更换体检人 ")
const _hoisted_8 = { class: "info hea-row hea-justifyCL" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "姓名", -1))
const _hoisted_10 = { class: "value border-r" }
const _hoisted_11 = {
  key: 0,
  class: "sex-icon",
  src: _imports_0,
  alt: ""
}
const _hoisted_12 = {
  key: 1,
  class: "sex-icon",
  src: _imports_1,
  alt: ""
}
const _hoisted_13 = { class: "my-list hea-flex-item1" }
const _hoisted_14 = { class: "tabs hea-row" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hea-justifyT tab-title hea-flex-item1" }, "视频问卷", -1))
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hea-justifyT tab-title hea-flex-item1" }, "核保体检", -1))
const _hoisted_19 = { class: "panel" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "panel-body-warp" }
const _hoisted_22 = { class: "panel-body-title" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "问卷", -1))
const _hoisted_25 = { class: "status hea-justifyCR" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_30 = { class: "form-list" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "任务编号", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "保单编号", -1))
const _hoisted_33 = { class: "warranty" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看更多", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "收起", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "开始时间", -1))
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "完成时间", -1))
const _hoisted_40 = { key: 1 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "失效时间", -1))
const _hoisted_42 = {
  key: 2,
  class: "date-tip"
}
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" 请于")
const _hoisted_44 = { class: "date-tip-txt" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("内继续视频问卷 ")
const _hoisted_46 = {
  key: 3,
  class: "date-tip"
}
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "panel-body-warp" }
const _hoisted_49 = { class: "panel-body-title" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "体检", -1))
const _hoisted_52 = { class: "status hea-justifyCR" }
const _hoisted_53 = { class: "form-list" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "任务编号", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "保单编号", -1))
const _hoisted_56 = { class: "warranty" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看更多", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "收起", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "开始时间", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "失效时间", -1))
const _hoisted_62 = { class: "notice-wrap" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "notice-title" }, "尊敬的先生/女士:", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "为了保证服务质量，维护您的权利，本次问卷将被全程录像，并成为友邦人寿为您办理保险合同相关业务的依据。", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 为实现视频问卷功能，友邦人寿需要收集本人的人脸识别信息和录音录像信息。人脸识别及录音录像信息属于敏感个人信息，即一旦泄露或者非法使用容易对个人权益造成影响的个人信息。如不提供前述敏感个人信息，友邦将无法实现所述目的。 ", -1))
const _hoisted_66 = /*#__PURE__*/_createTextVNode("本人已知晓并同意")
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "上次视频问卷中断，请您确认", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "是否继续", -1))
const _hoisted_70 = { class: "btn-list overlay-btn" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "上次视频问卷未完成签名，请您", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "确认是否补签", -1))
const _hoisted_74 = {
  class: "btn-list overlay-btn",
  style: {"padding":"0 16px"}
}
const _hoisted_75 = { class: "pop-nr" }
const _hoisted_76 = { class: "hea-row pop-header" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "null" }, null, -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title hea-flex-item1 hea-justifyB" }, "请选择体检人", -1))
const _hoisted_79 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "视频问卷服务工作时间为：9:00-21:00，请届时进行视频问卷服务。谢谢！", -1))
const _hoisted_82 = { class: "btn-list overlay-btn" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "当前来电高峰期，预计等待时间较长。", -1))
const _hoisted_85 = { class: "btn-list overlay-btn" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_87 = { class: "hea-justifyC" }
const _hoisted_88 = { class: "btn-list overlay-btn" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "请使用微信(6.5以上版本)点击链接或微信扫码进入视频问卷。", -1))
const _hoisted_91 = { class: "btn-list overlay-btn" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "当前您的手机型号或版本不支持视频问卷，建议您更换手机尝试，感谢您的支持与配合。", -1))
const _hoisted_94 = { class: "btn-list overlay-btn" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "overlay-wrapper-img",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hea-justifyC" }, "本次问卷大约需要15分钟,是否继续问卷。", -1))
const _hoisted_97 = { class: "btn-list overlay-btn" }

import { reactive, ref, onMounted, nextTick, computed } from "vue";
import { Toast } from "vant";
import tabbar from "src/components/common/tabbar";
import JSEncryptUtils from "utils/encrypt-utils";
import dayjs from "dayjs";
import { MemberService, TRTCService, PhysicalService } from "src/services";
import { useToken, useUserInfo } from "src/store";
import { useRouter } from "vue-router";
import UpageList from "src/components/common/page-list";
import PageBack from "src/components/common/page-back";
import config from "src/config";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { setAccessToken, setRefreshToken } = useToken();
const router = useRouter();
const { getUserInfo } = useUserInfo();
const $picker = ref();

let showWorking = ref<boolean>(false);
let state = reactive({
  // 问卷时间提示
  awaitModal: false,
  vacation: {
    showModal: false,
    msg: "",
  },
  isShowNotice: false,
  awaitNum: false,
  // 人员数组
  memberData: [],
  // 当前人员信息
  checkMember: {
    canPassFaceVerify: false,
    cardType: 1,
    hasProgressTask: false,
    id: null,
    isMainAccount: false,
    name: "",
    progressTaskId: null,
    progressTaskStatus: null,
    sex: null,
    sexStr: "",
  },
  // 当前选中
  currentSelectMember: {
    canPassFaceVerify: false,
    cardType: 1,
    hasProgressTask: false,
    id: null,
    isMainAccount: false,
    name: "",
    progressTaskId: null,
    progressTaskStatus: null,
    sex: null,
    sexStr: "",
  },
  currentQuestionnaireTask: {
    canPassFaceVerify: null,
    taskId: null,
    isIdCard: null,
  },
});

// 选择人员弹框
let show = ref<boolean>(false);

// 知晓
let showNotify = ref<boolean>(false);

// 异常中断
let showDiscontinue = ref<boolean>(false);

// 未签名
let showSign = ref<boolean>(false);

// 切换下标
let tabIndex = ref<number>(0);

// 浏览器弹框
let showBrowserModal = ref<boolean>(false);
// 手机型号弹框
let showPhoneModal = ref<boolean>(false);

let $questionnairepageList = ref(null);
let $physicalPageList = ref(null);
let filter = reactive({
  memberId: null,
});

/**
 * 视频问卷数据列表
 */
let getQuestionnaireList = async (parameter) => {
  try {
    if (tabIndex.value != 0) {
      return;
    }
    let { content: res } = await MemberService.instance.getQuestionnaireTaskPage(
      Object.assign(filter, parameter),
      false
    );
    return res.data;
  } catch (err) {
    Toast(err);
  }
};

// 判断是否为节假日
async function validateVacation() {
  try {
    let { content: result } = await PhysicalService.instance.validateVacation();
    // 判断是否可以问卷(节假日)
    if (result.data.isVacationQues) {
      // 判断是否在工作时间内
      if (!isWork.value) {
        showWorking.value = true;
        return;
      }
      let ua = navigator.userAgent.toLowerCase();
      // 浏览器
      if (!(ua.indexOf("micromessenger") > -1)) {
        // 请使用微信(6.5以上版本)点击链接或微信扫码进入视频问卷
        showBrowserModal.value = true;
        return;
      }

      // 手机型号
      if (ua.indexOf("iphone") > -1) {
        var ver = ua.match(/cpu iphone os (.*?) like mac os/);
        let versionList = ver[1].split("_");
        let version = `${versionList[0]}${versionList[1]}`;
        if (+version < 143) {
          showPhoneModal.value = true;
          return;
        }
      }
      let item: any = state.currentQuestionnaireTask;

      if (item.status == 1) {
        // 未进行
        if (await checkState()) {
          state.isShowNotice = true;
        } else {
          // 15分钟提醒
          state.awaitModal = true;
        }
      } else if (item.status == 2) {
        // 异常中断
        showDiscontinue.value = true;
      }
    } else {
      state.vacation.showModal = true;
      state.vacation.msg = result.data.msg;
    }
  } catch (err) {
    console.log(err);
  }
}

// 15分钟继续问卷
function onContinueQuestionnaire() {
  state.awaitModal = false;
  showNotify.value = true;
}

/**
 * 体检任务数据列表
 */
let getPhysicalTaskPage = async (parameter) => {
  try {
    if (tabIndex.value != 1) {
      return;
    }
    let { content: res } = await MemberService.instance.getPhysicalTaskPage(Object.assign(filter, parameter), false);

    return res.data;
  } catch (err) {
    Toast(err);
  }
};

// 确认
const onConfirmNotice = (): void => {
  if (!state.currentQuestionnaireTask.canPassFaceVerify) {
    // 身份证调人脸
    router.push({ name: "face-verify", query: { id: state.currentQuestionnaireTask.taskId + "" } });
  } else {
    router.push({ name: "calling", query: { id: state.currentQuestionnaireTask.taskId + "" } });
  }
};

let isWork = computed(() => {
  // 不在工作时间
  if (config.questionnaireConfig.enable) {
    let HH = +dayjs().format("HH");
    if (HH >= (config.questionnaireConfig.startDate || 9) && HH < (config.questionnaireConfig.endDate || 21)) {
      return true;
    }

    return false;
  }

  return true;
});

/**
 * 视频问卷详情
 */
let onQuestionnaireDetail = async (item) => {
  state.currentQuestionnaireTask = item;

  if (item.status == 3) {
    // 未签名
    showSign.value = true;
  } else {
    // 验证节假日和一些条件判断
    validateVacation();
  }
};

/**
 * 跳转详情
 */
let onPhysicalDetail = (item) => {
  //  体检任务
  router.push({ name: "detail", query: { id: item.taskId } });
};

/**
 * 格式化日期
 */
let formatDate = (date) => {
  return dayjs(date).format("YYYY年MM月DD日");
};

// 钩子
onMounted(() => {
  if (localStorage.getItem("currentSelectMember")) {
    let data = JSON.parse(localStorage.getItem("currentSelectMember"));
    filter.memberId = data.id + "";
  }
  getMember();
});

// 当前登入用户信息
let userInfo = computed(() => {
  return getUserInfo();
});

//
async function checkState() {
  try {
    let { content: result } = await TRTCService.instance.checkState(userInfo.value.userId + "");

    return result.data.isShowNotice;
  } catch (err) {
    console.log(err);
  }
}

// 获取客户端获取核保人员数据
const getMember = async (): Promise<void> => {
  try {
    let { content: reslut } = await MemberService.instance.getMembers();
    if (reslut.data) {
      if (localStorage.getItem("currentSelectMember")) {
        let data = JSON.parse(localStorage.getItem("currentSelectMember"));
        state.currentSelectMember = data;
        state.checkMember = data;
      } else {
        state.currentSelectMember = reslut.data[0];
        state.checkMember = reslut.data[0];
        filter.memberId = reslut.data[0].id + "";
      }

      state.memberData = reslut.data;
    }
  } catch (err) {
    Toast(err);
  }
};

const onGetPageList = (index: any) => {
  tabIndex.value = index;
  $questionnairepageList.value && $questionnairepageList.value.onRefresh();
  $physicalPageList.value && $physicalPageList.value.onRefresh();
};

// 补签
const countersign = () => {
  showSign.value = false;
  // 补签
  if (state.currentQuestionnaireTask.canPassFaceVerify) {
    // 可跳过人脸
    router.push({ name: "countersign", query: { id: state.currentQuestionnaireTask.taskId + "" } });
  } else {
    // 不可跳过人脸
    router.push({ name: "face-verify", query: { id: state.currentQuestionnaireTask.taskId + "", type: 2 } });
  }
};

// 异常中断
const continueQuestionnaire = () => {
  // 未进行
  router.push({ name: "calling", query: { id: state.currentQuestionnaireTask.taskId + "" } });
};

// 获取客户端获取核保人员数据
const onSelect = async (): Promise<void> => {
  try {
    let { content: reslut } = await MemberService.instance.getMembers();
    if (reslut.data) {
      state.memberData = reslut.data;

      reslut.data.forEach((item, index) => {
        if (item.id == state.currentSelectMember.id) {
          nextTick(() => {
            $picker.value.setColumnIndex(0, index);
          });
        }
      });
      show.value = true;
    }
  } catch (err) {
    Toast(err);
  }
};

// 确认
const onPickBtn = (): void => {
  state.checkMember = Object.assign({}, state.currentSelectMember);
  filter.memberId = state.checkMember.id + "";
  localStorage.setItem("currentSelectMember", JSON.stringify(state.currentSelectMember));
  $questionnairepageList.value && $questionnairepageList.value.onRefresh();
  $physicalPageList.value && $physicalPageList.value.onRefresh();
  show.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_count_down = _resolveComponent("van-count-down")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_overlay = _resolveComponent("van-overlay")!
  const _component_van_picker = _resolveComponent("van-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(PageBack)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          (_unref(state).memberData.length > 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "hea-row hea-justifyC exchange",
                onClick: onSelect
              }, [
                _createVNode(_component_van_icon, { name: "exchange" }),
                _hoisted_7
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(state).checkMember.name), 1),
          (_unref(state).checkMember.sex == 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_11))
            : (_openBlock(), _createElementBlock("img", _hoisted_12))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            class: _normalizeClass(["tab-li hea-row hea-flex-item1", _unref(tabIndex) == 0 ? 'active' : '']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onGetPageList(0)))
          }, [
            _createElementVNode("img", {
              src: _unref(tabIndex) == 0 ? '/images/my/questionnaire-active.png' : '/images/my/questionnaire.png',
              alt: "",
              class: "tab-img"
            }, null, 8, _hoisted_15),
            _hoisted_16
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-li hea-row hea-flex-item1", _unref(tabIndex) == 1 ? 'active' : '']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onGetPageList(1)))
          }, [
            _createElementVNode("img", {
              src: _unref(tabIndex) == 1 ? '/images/my/physical-active.png' : '/images/my/physical.png',
              alt: "",
              class: "tab-img"
            }, null, 8, _hoisted_17),
            _hoisted_18
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_19, [
          (_unref(state).memberData.length && _unref(tabIndex) == 0)
            ? (_openBlock(), _createBlock(_unref(UpageList), {
                key: 0,
                data: _unref(getQuestionnaireList),
                ref: (_value, _refs) => {
                  _refs['$questionnairepageList'] = _value
                  _isRef($questionnairepageList) ? $questionnairepageList.value = _value : $questionnairepageList = _value
                },
                noDataTitle: "暂无信息"
              }, {
                default: _withCtx((scoped) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["panel-body", { auto: scoped.item.active }]),
                    onClick: ($event: any) => (_unref(onQuestionnaireDetail)(scoped.item))
                  }, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _hoisted_24,
                        _createElementVNode("div", _hoisted_25, [
                          (scoped.item.status == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, "请进入"))
                            : (scoped.item.status == 2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, "请继续"))
                              : (scoped.item.status == 3)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, "请签名"))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _createTextVNode(_toDisplayString(scoped.item.statusStr), 1)
                                  ], 64)),
                          _hoisted_29,
                          (scoped.item.status != 4 && scoped.item.status != 5 && scoped.item.status != 6)
                            ? (_openBlock(), _createBlock(_component_van_icon, {
                                key: 4,
                                name: "arrow"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("ul", _hoisted_30, [
                        _createElementVNode("li", null, [
                          _hoisted_31,
                          _createElementVNode("div", null, _toDisplayString(scoped.item.taskNo), 1)
                        ]),
                        _createElementVNode("li", null, [
                          _hoisted_32,
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["warranty-warp", { auto: scoped.item.active }])
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scoped.item.policyNumbers, (d) => {
                                return (_openBlock(), _createElementBlock("span", { key: d }, _toDisplayString(d), 1))
                              }), 128))
                            ], 2),
                            (scoped.item.policyNumbers && scoped.item.policyNumbers.length > 2)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "more",
                                  onClick: _withModifiers(($event: any) => (scoped.item.active = !!!scoped.item.active), ["stop"])
                                }, [
                                  (!scoped.item.active)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_35,
                                        _createVNode(_component_van_icon, { name: "arrow-down" })
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _hoisted_36,
                                        _createVNode(_component_van_icon, { name: "arrow-up" })
                                      ], 64))
                                ], 8, _hoisted_34))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _hoisted_37,
                          _createElementVNode("div", null, _toDisplayString(scoped.item.issuedTime || "N"), 1)
                        ]),
                        (scoped.item.status == 4)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                              _hoisted_39,
                              _createElementVNode("div", null, _toDisplayString(scoped.item.statusChangedTime || "N"), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("li", _hoisted_40, [
                              _hoisted_41,
                              _createElementVNode("div", null, _toDisplayString(scoped.item.invalidateTime || "N"), 1)
                            ])),
                        (scoped.item.status == 2 && scoped.item.vedioCountdown > 0)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
                              _hoisted_43,
                              _createElementVNode("span", _hoisted_44, [
                                _createVNode(_component_van_count_down, {
                                  onFinish: _cache[2] || (_cache[2] = ($event: any) => (onGetPageList(_unref(tabIndex)))),
                                  time: scoped.item.vedioCountdown * 1000,
                                  format: "mm分ss秒"
                                }, null, 8, ["time"])
                              ]),
                              _hoisted_45
                            ]))
                          : _createCommentVNode("", true),
                        (scoped.item.status == 3)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_46, " 请于" + _toDisplayString(_unref(formatDate)(scoped.item.invalidateTime)) + "前完成补签 ", 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 10, _hoisted_20)
                ]),
                _: 1
              }, 8, ["data"]))
            : _createCommentVNode("", true),
          (_unref(state).memberData.length && _unref(tabIndex) == 1)
            ? (_openBlock(), _createBlock(_unref(UpageList), {
                key: 1,
                data: _unref(getPhysicalTaskPage),
                ref: (_value, _refs) => {
                  _refs['$physicalPageList'] = _value
                  _isRef($physicalPageList) ? $physicalPageList.value = _value : $physicalPageList = _value
                },
                noDataTitle: "暂无信息"
              }, {
                default: _withCtx((scoped) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["panel-body", { auto: scoped.item.active }]),
                    onClick: ($event: any) => (_unref(onPhysicalDetail)(scoped.item))
                  }, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _hoisted_51,
                        _createElementVNode("div", _hoisted_52, [
                          _createTextVNode(_toDisplayString(scoped.item.status == 1 && scoped.item.taskType == 2 ? "请预约" : scoped.item.statusStr) + " ", 1),
                          _createVNode(_component_van_icon, { name: "arrow" })
                        ])
                      ]),
                      _createElementVNode("ul", _hoisted_53, [
                        _createElementVNode("li", null, [
                          _hoisted_54,
                          _createElementVNode("div", null, _toDisplayString(scoped.item.taskNo), 1)
                        ]),
                        _createElementVNode("li", null, [
                          _hoisted_55,
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["warranty-warp", { auto: scoped.item.active }])
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scoped.item.policyNumbers, (d) => {
                                return (_openBlock(), _createElementBlock("span", { key: d }, _toDisplayString(d), 1))
                              }), 128))
                            ], 2),
                            (scoped.item.policyNumbers && scoped.item.policyNumbers.length > 2)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "more",
                                  onClick: _withModifiers(($event: any) => (scoped.item.active = !!!scoped.item.active), ["stop"])
                                }, [
                                  (!scoped.item.active)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_58,
                                        _createVNode(_component_van_icon, { name: "arrow-down" })
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _hoisted_59,
                                        _createVNode(_component_van_icon, { name: "arrow-up" })
                                      ], 64))
                                ], 8, _hoisted_57))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _hoisted_60,
                          _createElementVNode("div", null, _toDisplayString(scoped.item.issuedTime || "N"), 1)
                        ]),
                        _createElementVNode("li", null, [
                          _hoisted_61,
                          _createElementVNode("div", null, _toDisplayString(scoped.item.invalidateTime || "N"), 1)
                        ])
                      ])
                    ])
                  ], 10, _hoisted_47)
                ]),
                _: 1
              }, 8, ["data"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _unref(showNotify),
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_isRef(showNotify) ? (showNotify).value = $event : showNotify = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_62, [
          _hoisted_63,
          _hoisted_64,
          _hoisted_65,
          _createVNode(_component_van_button, {
            round: "",
            color: "linear-gradient(to right, #F8628A, #E23A67)",
            class: "pick-btn notice-btn",
            onClick: onConfirmNotice
          }, {
            default: _withCtx(() => [
              _hoisted_66
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(showDiscontinue),
      class: "notice-overlay",
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_isRef(showDiscontinue) //@ts-ignore
 ? showDiscontinue.value = false : showDiscontinue = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_67,
          _hoisted_68,
          _hoisted_69,
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("button", {
              class: "btn-cancel van-hairline--surround",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_isRef(showDiscontinue) //@ts-ignore
 ? showDiscontinue.value = false : showDiscontinue = false))
            }, "取消"),
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: continueQuestionnaire
            }, "继续问卷")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(showSign),
      class: "notice-overlay",
      onClick: _cache[9] || (_cache[9] = ($event: any) => (_isRef(showSign) //@ts-ignore
 ? showSign.value = false : showSign = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          style: {"padding-left":"0","padding-right":"0"},
          onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_71,
          _hoisted_72,
          _hoisted_73,
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("button", {
              class: "btn-cancel van-hairline--surround",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_isRef(showSign) //@ts-ignore
 ? showSign.value = false : showSign = false))
            }, "取消"),
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: countersign
            }, "补签")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(tabbar)),
    (_unref(show))
      ? (_openBlock(), _createBlock(_component_van_popup, {
          key: 0,
          show: _unref(show),
          "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => (_isRef(show) ? (show).value = $event : show = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_75, [
              _createVNode(_component_van_picker, {
                swipeDuration: 10,
                ref: (_value, _refs) => {
                  _refs['$picker'] = _value
                  $picker.value = _value
                },
                title: "请选择体检人",
                columns: _unref(state).memberData,
                onChange: _cache[11] || (_cache[11] = 
            (event) => {
              _unref(state).currentSelectMember = event;
            }
          )
              }, {
                toolbar: _withCtx(() => [
                  _createElementVNode("div", _hoisted_76, [
                    _hoisted_77,
                    _hoisted_78,
                    _createElementVNode("div", {
                      class: "close",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_isRef(show) //@ts-ignore
 ? show.value = false : show = false))
                    }, [
                      _createVNode(_component_van_icon, { name: "cross" })
                    ])
                  ])
                ]),
                option: _withCtx((item) => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 1
              }, 8, ["columns"]),
              _createVNode(_component_van_button, {
                round: "",
                color: "linear-gradient(to right, #F8628A, #E23A67)",
                class: "pick-btn",
                onClick: onPickBtn
              }, {
                default: _withCtx(() => [
                  _hoisted_79
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["show"]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_overlay, {
      show: _unref(showWorking),
      class: "notice-overlay"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_80,
          _hoisted_81,
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_isRef(showWorking) //@ts-ignore
 ? showWorking.value = false : showWorking = false))
            }, "确定")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(state).isShowNotice,
      class: "notice-overlay",
      onClick: _cache[17] || (_cache[17] = ($event: any) => (_unref(state).isShowNotice = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_83,
          _hoisted_84,
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("button", {
              class: "btn-cancel van-hairline--surround",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(state).isShowNotice = false))
            }, "挂断"),
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: continueQuestionnaire
            }, "继续等待")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(state).vacation.showModal,
      class: "notice-overlay",
      onClick: _cache[20] || (_cache[20] = ($event: any) => (_unref(state).vacation.showModal = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_86,
          _createElementVNode("p", _hoisted_87, _toDisplayString(_unref(state).vacation.msg), 1),
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("button", {
              class: "btn-cancel van-hairline--surround",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_unref(state).vacation.showModal = false))
            }, "确定")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(showBrowserModal),
      class: "notice-overlay",
      onClick: _cache[23] || (_cache[23] = ($event: any) => (_isRef(showBrowserModal) //@ts-ignore
 ? showBrowserModal.value = false : showBrowserModal = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_89,
          _hoisted_90,
          _createElementVNode("div", _hoisted_91, [
            _createElementVNode("button", {
              class: "btn-cancel van-hairline--surround",
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_isRef(showBrowserModal) //@ts-ignore
 ? showBrowserModal.value = false : showBrowserModal = false))
            }, "确定")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(showPhoneModal),
      class: "notice-overlay",
      onClick: _cache[26] || (_cache[26] = ($event: any) => (_isRef(showPhoneModal) //@ts-ignore
 ? showPhoneModal.value = false : showPhoneModal = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_92,
          _hoisted_93,
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("button", {
              class: "btn-cancel van-hairline--surround",
              onClick: _cache[24] || (_cache[24] = ($event: any) => (_isRef(showPhoneModal) //@ts-ignore
 ? showPhoneModal.value = false : showPhoneModal = false))
            }, "确定")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_overlay, {
      show: _unref(state).awaitModal,
      class: "notice-overlay",
      onClick: _cache[30] || (_cache[30] = ($event: any) => (_unref(state).awaitModal = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "overlay-wrapper",
          onClick: _cache[29] || (_cache[29] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_95,
          _hoisted_96,
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("button", {
              class: "btn-cancel van-hairline--surround",
              onClick: _cache[27] || (_cache[27] = ($event: any) => (_unref(state).awaitModal = false))
            }, "下次再问"),
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[28] || (_cache[28] = ($event: any) => (onContinueQuestionnaire()))
            }, "继续问卷")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})